import { AxiosInstance } from 'axios';
import { IWispBiosample, IWispBiosampleFilters } from '@zero-dash/types';

export interface ILiquidBiopsyClient {
  getWispBiosamples: (filters: IWispBiosampleFilters) => Promise<IWispBiosample[]>;
}

export function createLiquidBiopsyClient(instance: AxiosInstance): ILiquidBiopsyClient {
  async function getWispBiosamples(filters: IWispBiosampleFilters): Promise<IWispBiosample[]> {
    const resp = await instance.get<IWispBiosample[]>('/liquid-biopsy/wisp', {
      params: { ...filters },
    });
    return resp.data;
  }

  return { getWispBiosamples };
}